class EventBus {
    constructor() {
        this._events = {}
    }

    on (event, callback) {
        if(Array.isArray(event)) {
            event.forEach(ev => this.on(ev, callback));
        } else {
            if(!this._events[event]) {
                this._events[event] = [];
            }

            this._events[event].push(callback);
        }

        return this;
    }

    once (event, callback) {
        function on () {
            this.off(event, on);
            callback.apply(this, arguments);
        }

        on.callback = callback;
        this.on(event, on);

        return this;
    }

    off (event, callback) {
        if (!arguments.length) {
            this._events = Object.create(null);
            return this;
        }

        if(Array.isArray(event)) {
            event.forEach(ev => this.off(ev, callback));
            return this;
        }

        let callbacks = this._events[event];

        if(!callbacks) {
            return this;
        }

        if(!callback) {
            this._events[event] = [];
            return this;
        }

        let cb;
        let i = callbacks.length;

        while(i--) {
            cb = callbacks[i];

            if(cb === callback || cb.fn === callback) {
                callbacks.splice(i, 1);
                break;
            }
        }

        return this;
    }

    emit (event, ...payload) {
        let callbacks = this._events[event];

        if(callbacks) {
            callbacks.forEach(callback => callback(...payload))
        }

        return this
    }

    registerElementListener (element) {
        const [domEvent, busEvent] = (`${element.dataset.eventBus}:`).split(':');

        if(!domEvent || !busEvent) {
            console.warn('EventBus DOM Element binding data is incomplete.', element);
            return;
        }

        element.addEventListener(domEvent, () => this.emit(busEvent, element));
    }
}

const bus = new EventBus

document.querySelectorAll('[data-event-bus]').forEach(element => bus.registerElementListener(element))

export default bus
